import { ResponsiveContext } from 'grommet';
import { useContext } from 'react';

const useResponsive = () => {
  const size = useContext(ResponsiveContext);
  const isMobile = size === 'small';
  return { isMobile, size };
};

export default useResponsive;
